import { Descriptions, Divider } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { numberWithCommas } from "../../../../utils";

function EmployementTermsView() {
  const { activeObjJob } = useSelector((state) => ({
    activeObjJob: state.folder.activeObj["job"],
  })); 
  const items1 = [
    {
      key: "1",
      label: "Experienced required",
      children: activeObjJob?.jobExperienceLevel ?? "N/A",
    },
    {
      key: "2",
      label: "Payment Frequency",
      children: activeObjJob?.jobPayFrequency ?? "N/A",
    },
    {
      key: "3",
      label: "Terms of Employment",
      children: activeObjJob?.jobEmploymentTerms ?? "N/A",
    },

    {
      key: "5",
      label: "Length of employment",
      children: activeObjJob?.jobDuration ?? "N/A",
    },
    {
      key: "6",
      label: "Start Period",
      children: activeObjJob?.jobStartPeriod ?? "N/A",
    },
    {
      key: "7",
      label: "Work Type",
      children: activeObjJob?.jobWorkType ?? "N/A",
    },
    {
      key: "8",
      label: "Gross pay currency",
      children: activeObjJob?.jobCurrency ?? "N/A",
    },
    {
      key: "9",
      label: "Salary Confidentiality",
      children: activeObjJob?.jobSalaryConfidentiality ? "Yes" : "No",
    },
    {
      key: "10",
      label: "Gross pay",
      children: <div>{numberWithCommas(activeObjJob?.jobGrossPay)}</div>,
    },
  ];
  const items2 = [
    {
      key: "1",
      label: "",
      children: activeObjJob?.jobRecruitmentProcess?.join("    ,    ") ?? "N/A",
    },
  ];
  return (
    <div className="lg:w-[50rem] w-full mt-[2.5rem]">
      <div className="text-[#0B363D] font-[600] text-[1.5rem] font-dmSans">
        3. Terms of Employment
      </div>
      <div className="mt-[1rem] mb-[1.5rem]">
        <Divider />
      </div>

      <div className="mt-[1.5rem] mb-[1.5rem] text-[#0B363D] text-[1.125rem] font-[500] font-dmSans">
        Terms
      </div>

      <Descriptions
        title=""
        column={2}
        colon={false}
        items={items1}
        layout="vertical"
      />

      <div className="mt-[1.5rem]  text-[#0B363D] text-[1.125rem] font-[500] font-dmSans">
        Recruitment Process
      </div>

      <Descriptions
        title=""
        column={1}
        colon={false}
        items={items2}
        layout="vertical"
      />
    </div>
  );
}

export default EmployementTermsView;
